/** 用於 Suspense fallback用：讀取中fallback */

export default function LoadingElement() {
  const keyframes = `
  .firstDot {
    animation: firstDot 1s infinite;
  }
  @keyframes firstDot{
    0%{
      transform: translateY(0);
    }
    20%{
      transform: translateY(-10px);
    }
    40%{
      transform: translateY(0);
    }
    60%{
      transform: translateY(0);
    }
    100%{
      transform: translateY(0);
    }
  }
  .secondDot {
    animation: secondDot 1s infinite;
  }
  @keyframes secondDot{
    0%{
      transform: translateY(0);
    }
    20%{
      transform: translateY(0);
    }
    40%{
      transform: translateY(-10px);
    }
    60%{
      transform: translateY(0);
    }
    100%{
      transform: translateY(0);
    }
  }
  .thirdDot {
    animation: thirdDot 1s infinite;
  }
  @keyframes thirdDot{
    0%{
      transform: translateY(0);
    }
    20%{
      transform: translateY(0);
    }
    40%{
      transform: translateY(0);
    }
    60%{
      transform: translateY(-10px);
    }
    100%{
      transform: translateY(0);
    }
  }
  .loadingDots{
    font-size:1.4rem;
    padding-left: 8px;
  }

`;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "32px",
        paddingBottom: "32px",
        fontSize: "1.2em",
        fontWeight: "bold",
        cursor: 'wait'
      }}
    >
      Loading
      <span className="loadingDots firstDot">.</span>
      <span className="loadingDots secondDot">.</span>
      <span className="loadingDots thirdDot">.</span>
      <style>{keyframes}</style>
    </div>
  );
}
